import { Input } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/Input';
import { CardContent } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/viewModels/CardContent';
import { v4 as uuid } from 'uuid';
export class InputViewModel extends Input {
    static $inject = ['init'];
    constructor(init) {
        super();
        Object.assign(this, init);
    }
    static create(textContent, inputState, deletable = true) {
        let inputStateObj;
        if (inputState) {
            inputStateObj = inputState;
        }
        else {
            inputStateObj = new Input();
            inputStateObj.bypass = true;
        }
        const $cardContent = CardContent.create({
            id: uuid(),
            type: 'text/plain',
            textContent,
        }, 'right', false, deletable);
        return new InputViewModel({
            ...inputStateObj,
            $cardContent,
        });
    }
}
